import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

const AccessDenied = ({
  title = "Access Denied",
  message = "You don't have permission to access this resource.",
  icon = (
    <LockOutlinedIcon sx={{ fontSize: 60, color: "warning.main", mb: 2 }} />
  ),
  showBackButton = true,
  customAction = null,
  height = "100vh",
  iconColor = "warning.main",
  titleColor = "warning.main",
  messageColor = "text.secondary",
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: height,
        p: 3,
        textAlign: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
      }}
    >
      {icon}
      <Typography variant='h5' color={titleColor} gutterBottom>
        {title}
      </Typography>
      <Typography variant='body1' color={messageColor} sx={{ mb: 3 }}>
        {message}
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        {showBackButton && (
          <Button
            variant='outlined'
            color='primary'
            onClick={() => navigate(-1)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              px: 3,
            }}
          >
            Go Back
          </Button>
        )}
        {customAction}
      </Box>
    </Box>
  );
};

export default AccessDenied;
